import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Progress} from 'kpc';

var _$tmp0 = {
    'percent': '50'
};
var _$tmp1 = {
    'percent': '50',
    'size': 'small'
};
var _$tmp2 = {
    'percent': '50',
    'size': 'mini'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Progress, _$tmp0),
        _$cc(Progress, _$tmp1),
        _$cc(Progress, _$tmp2)
    ], 4);
};